import styled from 'styled-components';
import { motion } from 'framer-motion';
import { min } from '../../../theme/breakpoints';

type AccordionQuestionAnswerProps = {
  active: boolean;
};

export const ItemContainer = styled(motion.li)``;

export const AccordionQuestion = styled.button<AccordionQuestionAnswerProps>`
  appareance: none;
  border: 0;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 0 0;
  position: relative;
  width: 100%;
  cursor: pointer;
  font-size: 1.125rem;
  font-family: ${({ theme }) => theme.fonts.primary.bold};
  color: ${({ theme }) => theme.colors.text};
  border-bottom: 4px solid ${({ theme }) => theme.colors.RipeLemon};
  text-align: left;
  line-height: 1.2;

  @media screen and ${min('tablet')} {
    padding: 2rem 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.text};
  }
  @media screen and ${min('largeTablet')} {
    font-size: 1.5rem;
  }
  svg {
    margin-left: 1rem;
    flex: 0 0 0.875rem;
    transition: 0.4s all ease;
    transform: ${({ active }) => (active ? 'rotate(0deg)' : 'rotate(180deg)')};

    @media screen and ${min('largeTablet')} {
      flex: 0 0 1rem;
    }
    path {
      fill: ${({ theme }) => theme.colors.text};
    }
  }
  > span {
    position: relative;

    span {
      position: relative;
      z-index: 1;
    }
    &::after {
      content: '';
      display: none;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 1.5rem;
      height: 6px;
      background-color: ${({ theme }) => (theme.name === 'uplay' ? theme.colors.HavelockBlue : theme.colors.RipeLemon)};
      z-index: 0;
      transition: 0.2s all ease-in-out;

      @media screen and ${min('tablet')} {
        display: block;
      }
    }
  }
  @media screen and ${min('largeTablet')} {
    &:hover {
      > span::after {
        right: 0;
      }
    }
  }
`;

export const AccordionAnswer = styled.div<AccordionQuestionAnswerProps>`
  overflow: hidden;
  text-align: left;
  transition: max-height 0.4s ease;
  margin: 0;

  p {
    font-size: 1rem;
    line-height: 1.5;
    max-width: 1000px;
    padding: 0;
    text-align: left;
    visibility: ${(props) => (props.active ? 'visible' : 'hidden')};
    transition: visibility;
    transition-delay: ${(props) => (props.active ? '0s' : '0.1s')};

    &:first-child {
      padding: 2rem 0 0;
    }
  }
  ul {
    list-style: disc;
    padding-left: 2rem;
  }
  a {
    font-family: ${({ theme }) => theme.fonts.primary.regular};
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.text};
    transition: 0.2s all ease-in-out;

    @media screen and ${min('largeTablet')} {
      &:hover {
        opacity: 0.5;
      }
    }
  }
`;
